import { call, put, takeEvery } from "redux-saga/effects";
import axios from "axios";

// Login Redux States
import { LOGIN_USER, LOGOUT_USER } from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess } from "./actions";

//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";

const fireBaseBackend = getFirebaseBackend();

function* loginUser({ payload: { user, history } }) {
  try {
    const response = yield call(
      axios.post,
      process.env.REACT_APP_WEB_APP_URL + "/api/web-login",
      user
    );

    const { token, user: userData } = response.data.data;

    localStorage.setItem("authUser", JSON.stringify(userData));
    localStorage.setItem("authToken", token);
    localStorage.setItem("isProfileLocked", false);
    localStorage.setItem("authUserPassword", user.password);

    yield put(loginSuccess(userData));
    history("/dashboard");

  } catch (error) {
    let message = "Something went wrong";
    if (error.response && error.response.data && error.response.data.message) {
      message = error.response.data.message;
      console.log(error);
      
    }

    yield put(apiError(message));
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem("authUser");
    localStorage.removeItem("authToken");
    localStorage.removeItem("isProfileLocked");
    localStorage.removeItem("authUserPassword");

    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = yield call(fireBaseBackend.logout);
      yield put(logoutUserSuccess(response));
    }
    history("/login");
  } catch (error) {
    yield put(apiError(error));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
